import { render, staticRenderFns } from "./activityCOAttainment.html?vue&type=template&id=a1296c64&scoped=true&external"
import script from "./activityCOAttainment.vue?vue&type=script&lang=js"
export * from "./activityCOAttainment.vue?vue&type=script&lang=js"
import style0 from "./activityCOAttainment.css?vue&type=style&index=0&id=a1296c64&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1296c64",
  null
  
)

export default component.exports